// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ffSnU","title":"Header_title__8b2-k","side":"Header_side__252Ld"};